import { Fragment } from 'react';
import { UMCoordinateSystemSelector, UMInputNumber, type UMCoordinateSystemValue } from '@urbanmetrix/um-kit';
import { InlineInfoIcon } from 'components/icons';
import type { BorderType, Lv95Coordinate } from './cadastralShared';

interface Props {
  borderType: BorderType | null;
  coordinates: Lv95Coordinate[];
  coordinateInputs: Array<{ x: string; y: string }>;
  disabled: boolean;
  selectorValue: UMCoordinateSystemValue;
  onSelectorChange: (value: UMCoordinateSystemValue) => void;
  onValidationChange: (isValid: boolean) => void;
  onCoordinateChange: (index: number, axis: 'x' | 'y', value: string | number) => void;
  toDisplayCoordinate: (coordinate: Lv95Coordinate) => Lv95Coordinate;
}

const CadastralCoordinateEditor = ({
  borderType,
  coordinates,
  coordinateInputs,
  disabled,
  selectorValue,
  onSelectorChange,
  onValidationChange,
  onCoordinateChange,
  toDisplayCoordinate,
}: Props) => (
  <div className="grid-coordinate-editor">
    <h3 className="grid-coordinate-editor__title">
      Edit{' '}
      {borderType === 'legalBorder'
        ? 'Property Area'
        : borderType === 'buildableBorder'
          ? 'Buildable Area'
          : 'Analysis Area'}
    </h3>

    <UMCoordinateSystemSelector
      title="Coordinates System:"
      disabled={disabled}
      helpIcon={<InlineInfoIcon />}
      value={selectorValue}
      alignRadios={true}
      titleTooltip="Local Swiss LV95 uses the default Swiss reference system. Custom Coords lets you define your custom anchor point (always in LV95 Swiss reference system). This setting is applied at grid level."
      onChange={onSelectorChange}
      onValidationChange={({ isValid }) => onValidationChange(isValid)}
    />

    <div className="grid-coordinate-editor__grid">
      <div className="grid-coordinate-editor__axis">X</div>
      <div className="grid-coordinate-editor__axis">Y</div>
      {coordinates.map((coordinate, index) => {
        const displayCoordinate = toDisplayCoordinate(coordinate);
        return (
          <Fragment key={index}>
            <div>
              <UMInputNumber
                label=""
                name={`coordinate-x-${index}`}
                value={coordinateInputs[index]?.x ?? String(displayCoordinate.x)}
                width={109}
                maxErrorMessageWidth={276}
                onChange={(_name, value) => onCoordinateChange(index, 'x', value)}
              />
            </div>
            <div>
              <UMInputNumber
                label=""
                name={`coordinate-y-${index}`}
                value={coordinateInputs[index]?.y ?? String(displayCoordinate.y)}
                width={109}
                maxErrorMessageWidth={276}
                onChange={(_name, value) => onCoordinateChange(index, 'y', value)}
              />
            </div>
          </Fragment>
        );
      })}
    </div>
  </div>
);

export default CadastralCoordinateEditor;
